enum SectionName {
  Doors = 'doors',
  ModelVersion = 'modelVersion',
  Options = 'options',
  Trim = 'trim',
  TruckBodyStyle = 'truckBodyStyle',
  Year = 'year'
}

export default SectionName;
